import { useCallback } from 'react'
import { ConversationChatDrawer } from '../../../components/chat/conversation-chat-drawer'
import { useViewActions } from '../../../view-atoms'
import { useDismissMeetingChatDrawer, useSettleMeetingChatFreshSubmit } from '../use-meeting-chat-drawer'

interface MeetingChatDrawerProps {
  chatId: string
  open: boolean
  entranceSettled: boolean
  isFreshSubmit?: boolean
}

/**
 * The meeting-scoped thread: chatting about a meeting slides its conversation
 * up over the Meeting View rather than stacking a Chat View, so the transcript,
 * summary, and recording controls stay where the user left them.
 */
export function MeetingChatDrawer({ chatId, open, entranceSettled, isFreshSubmit }: MeetingChatDrawerProps) {
  const { openView } = useViewActions()
  const dismiss = useDismissMeetingChatDrawer()
  const settleFreshSubmit = useSettleMeetingChatFreshSubmit()
  const handleStagedActionClick = useCallback(
    (actionId: string) => openView('action', { actionId }, { sourceLabel: 'Meeting' }),
    [openView],
  )

  return (
    <ConversationChatDrawer
      chatId={chatId}
      open={open}
      entranceSettled={entranceSettled}
      isFreshSubmit={isFreshSubmit}
      onFreshSubmitSettled={settleFreshSubmit}
      onDismiss={dismiss}
      onStagedActionClick={handleStagedActionClick}
      sourceLabel="Meeting"
    />
  )
}
